import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { inject, Injector, ModuleWithProviders, NgModule, provideAppInitializer } from '@angular/core';
import { provideTranslateService, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { FOR_ROOT_OPTIONS_TOKEN, I18nOptions, ModuleOptions, provideI18nOptions, TranslateInitializerFactory } from './i18n.config';

@NgModule({
  imports: [TranslatePipe],
  exports: [TranslatePipe],
  providers: [
    // @ngx-translate 18: TranslateModule.forRoot() → provideTranslateService(); the HTTP loader is configured via provideTranslateHttpLoader().
    // Provided ONCE at root — never re-provide TranslateService elsewhere (a bare provider = isolated instance without language).
    provideTranslateService({
      fallbackLang: 'en',
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: `.json?version=${new Date().getTime()}`,
        // keep the previous behaviour: a missing translation file fails the language load
        failOnError: true
      })
    }),
    provideAppInitializer(() => {
      const initializerFn = TranslateInitializerFactory(inject(TranslateService), inject(Injector));
      return initializerFn();
    }),
    provideHttpClient(withXhr(), withInterceptorsFromDi())
  ]
})
export class I18nModule {
  static forRoot(options?: ModuleOptions): ModuleWithProviders<I18nModule> {
    return {
      ngModule: I18nModule,
      providers: [
        {
          provide: FOR_ROOT_OPTIONS_TOKEN,
          useValue: options
        },
        {
          provide: I18nOptions,
          useFactory: provideI18nOptions,
          deps: [FOR_ROOT_OPTIONS_TOKEN]
        }
      ]
    };
  }
}
